module.exports = __webpack_public_path__ + "img/1584499329.17ddcb57.jpg";